import { render, staticRenderFns } from "./KeywordRow.vue?vue&type=template&id=60a7205f&scoped=true&"
import script from "./KeywordRow.vue?vue&type=script&lang=js&"
export * from "./KeywordRow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60a7205f",
  null
  
)

export default component.exports